import axiosRequest from "@/utils/axiosRequest";

export function callingReport(data) {
  return axiosRequest({
    url: `/robot/callingReport`,
    data,
    method: "post"
  });
}

export function list(data) {
  return axiosRequest({
    url: `/robot/list`,
    data,
    method: "post"
  });
}

export function listByGroup(data) {
  return axiosRequest({
    url: `/robot/listByGroup`,
    data,
    method: "post"
  });
}

export function listFunction(data) {
  return axiosRequest({
    url: `/account/listFunction`,
    data,
    method: "post"
  });
}

export function run(data) {
  return axiosRequest({
    url: `/robot/run`,
    data,
    method: "post"
  });
}

export function stop(data) {
  return axiosRequest({
    url: `/robot/stop`,
    data,
    method: "post"
  });
}

export function upgrade(data) {
  return axiosRequest({
    url: `/robot/upgrade`,
    data,
    method: "post"
  });
}

export function config(data) {
  return axiosRequest({
    url: `/robot/config`,
    data,
    method: "post"
  });
}

export function monitor(data) {
  return axiosRequest({
    url: `/robot/monitor`,
    data,
    method: "post"
  });
}

export function getImg(data) {
  return axiosRequest({
    url: `/robot/getImg`,
    data,
    method: "post"
  });
}

export function getItemList(data) {
  return axiosRequest({
    url: `/robot/getItemList`,
    data,
    method: "post"
  });
}

export function udpateItem(data) {
  return axiosRequest({
    url: `/robot/udpateItem`,
    data,
    method: "post"
  });
}

export function retry(data) {
  return axiosRequest({
    url: `/robot/retry`,
    data,
    method: "post"
  });
}

